import { InitConsultationRequestData } from '../../../types/models/consultations/init.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseAvailableCompaniesResponse } from './useAvailableCompanies.types';

const PREFIX = '[availableCompaniesQuery]';

export const queryAvailableCompanies = async (data: InitConsultationRequestData) => {
  console.log(PREFIX, `Fetching available companies for ${data.title}...`);
  const response = await CONSULTATIONS_ENDPOINTS.availableCompanies(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received available companies for ${data.title}.`);
  return json as UseAvailableCompaniesResponse;
};
